import { z } from 'zod'
import { descriptionParamsSchema } from './data'
import { widgetSchema } from '../../common/schema'

export const descriptionSectionKeys = [
  'short_summary', 'summary', 'notes', 'access', 'transit',
  'interaction', 'neighbourhood', 'space', 'house_manual',
] as const

export type DescriptionSectionKey = typeof descriptionSectionKeys[number]

export const descriptionWidgetConfig = widgetSchema.extend({
  section: z.object({
    show: z.boolean().default(false).describe('Show the section title above the widget content'),
    title: z.string().nullish().default('About this property').describe('Section title text'),
  }).default({ show: false, title: 'About this property' }).describe('Section heading shown above the widget content'),
  filter: descriptionParamsSchema,
  displayOrder: z.object({
    orderInDialog: z.array(z.enum(descriptionSectionKeys)).default([...descriptionSectionKeys]).describe('The order of sections in the dialog'),
  }).default({
    orderInDialog: [...descriptionSectionKeys],
  }).describe('The display order of description sections'),
  translations: z.object({
    showMoreButton: z.record(z.string(), z.string()).default({
      en_US: 'Show More',
    }).describe('Show more button text for different locales'),
  }).default({
    showMoreButton: { en_US: 'Show More' },
  }).describe('Widget translations'),
  excerptPropertyName: z.enum(descriptionSectionKeys).default('short_summary').describe('The property name shown as excerpt'),
  showMoreButton: z.boolean().default(true).describe('Whether to show the more button'),
})

export type DescriptionWidgetConfig = z.infer<typeof descriptionWidgetConfig>
